// import React from "react";
// import "./BreadcrumComponent.css";
// import Breadcrumb from "react-bootstrap/Breadcrumb";
// import { Link } from "react-router-dom";
// const BreadcrumComponent = ({ items }) => {
//   return (
//     <>
//       <div className="BreadcrumComponent">
//         <Breadcrumb>
//           {items?.map((item, index) => (
//             <Breadcrumb.Item
//               key={index}
//               linkAs={Link}
//               linkProps={{ to: item.link }}
//               className={item.className}
//             >
//               {item?.text}
//             </Breadcrumb.Item>
//           ))}
//         </Breadcrumb>
//       </div>
//     </>
//   );
// };

// export default BreadcrumComponent;

import React from "react";
import "./BreadcrumComponent.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const BreadcrumComponent = ({ items }) => {
  return (
    <div className="BreadcrumComponent">
      <Breadcrumb>
        {items?.map((item, index) => (
          <React.Fragment key={index}>
            <Breadcrumb.Item
              linkAs={Link}
              linkProps={{ to: item.link }}
              className={item.className}
            >
              {item?.text}
            </Breadcrumb.Item>

            {index < items.length - 1 && (
              <FontAwesomeIcon
                icon={faChevronRight}
                className="breadcrumb_separator"
              />
            )}
          </React.Fragment>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default BreadcrumComponent;
